<template>
  <div>
    <h1>Taxímetros Asignados</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar taxímetro"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getVehicles"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:[mycell()]="row">
        <b-badge v-if="row.item.taximeter.status" variant="success">Activo</b-badge>
        <b-badge v-else variant="warning">Inactivo</b-badge>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getVehicles.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
// import { encrypt } from '@/config/headers'
export default {
  name: 'AssignedTaximeters',
  data() {
    return {
      getVehicles: [],
      fields: [
        { key: 'taximeter.id', label: 'ID', sortable: true, sortDirection: 'desc' },
        { key: 'taximeter.serialNumber', label: 'Número de Serie' },
        { key: 'taximeter.status', label: 'Estatus' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      idDelete: null,
    }
  },
  apollo: {
    getVehicles: {
      query: gql`
        query{
          getVehicles{
            id
            taximeter{
              id
              serialNumber
              status
            }
          }
        }
      `,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      result({ data }) {
        console.log(data.getVehicles)
        this.getVehicles = data.getVehicles.filter(item => { return item.taximeter !== null })
        this.totalRows = this.getVehicles.length
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    mycell() {
      return 'cell(taximeter.status)'// simple string interpolation
    },
  },
}
</script>
<style scoped>

</style>
